module.exports = __webpack_public_path__ + "img/9788952790316.0797e7c4.jpg";